import { BuilderComponent } from "@builder.io/react";
import { useRouter } from "next/router";

import { analytics } from "@flare/analytics";
import { useTranslation } from "@flare/i18n";

import { sectionModel } from "@/builder/model-names";
import { BiEventsNames } from "@/services/analytics/bi-event-names";

import { Footer } from "../components/footer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { useConfirmationPageBuilderComponents } from "../hooks/use-confirmation-page-builder-components";

import { ConfirmationLssBanner } from "./components/confirmation-lss-banner";
import { ConfirmationNextSteps } from "./components/confirmation-next-steps";
import { ConfirmationSection } from "./components/confirmation-section";
import type { StepProps } from "./step.types";

export default function IntakeConfirmation({ answers }: StepProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const data = answers ? answers : {};
  const practice = router.query.practice ?? data?.practice;

  const { builderComponents } = useConfirmationPageBuilderComponents();

  const ctaUrl = "/";
  const isQualifiedForLss = answers?.isQualifiedForLss;

  function ctaClickHandler() {
    analytics.track(BiEventsNames.WebFunnelClick, {
      practice,
      current_step_key: "intake-confirmation",
      answer_value: Object.entries(data).flat().toString(),
      full_answer: JSON.stringify(data),
      click_type: "link",
      click_text: t("FUNNEL_STEP_INTAKE_CONFIRMATION_CTA"),
    });
  }

  return (
    <>
      <StepContainer>
        <StepContent className="flex flex-col justify-center pb-sp-8 pt-sp-4 md:items-center md:px-[64px]">
          <ConfirmationSection
            ctaText={t("FUNNEL_STEP_INTAKE_CONFIRMATION_CTA")}
            ctaUrl={ctaUrl}
            status={t("FUNNEL_STEP_INTAKE_CONFIRMATION_STATUS")}
            title={t("FUNNEL_STEP_INTAKE_CONFIRMATION_TITLE")}
            ctaClickHandler={ctaClickHandler}
            showCta={!isQualifiedForLss}
          >
            <ConfirmationNextSteps />
          </ConfirmationSection>
          {isQualifiedForLss && <ConfirmationLssBanner />}
        </StepContent>
        {builderComponents?.marbleBenefits && (
          <BuilderComponent
            model={sectionModel.symbol}
            content={builderComponents.marbleBenefits}
          />
        )}
        {builderComponents?.reviews && (
          <BuilderComponent
            model={sectionModel.symbol}
            content={builderComponents.reviews}
          />
        )}
      </StepContainer>
      <Footer className="h-auto" />
    </>
  );
}
